import { BulkCreateCompanyWizardProvider } from "../components/BulkCreateCompanyWizardProvider";
import {
  BULK_CREATE_COMPANY_BASE_PATH,
  BulkCreateFlowProvider,
} from "./bulkCreateFlow";
import s from "./BulkCreateCompanyRedesignLayout.module.css";

/**
 * Cloned bulk-create flow with the card preview instead of the stacked CSV
 * table. Upload and Review share one working screen, so this redesign omits
 * the legacy progress stepper and treats Results as a completion state.
 */
export function BulkCreateCompanyRedesignLayout() {
  return (
    <BulkCreateFlowProvider
      basePath={BULK_CREATE_COMPANY_BASE_PATH}
      presentation="cards"
      title="Bulk create companies"
    >
      <div className={s.container}>
        <BulkCreateCompanyWizardProvider />
      </div>
    </BulkCreateFlowProvider>
  );
}
